import dynamic from 'next/dynamic';
import { CURRENCIES } from '../../../../types';
import { CashDepositModalProps } from '../CashDepositModal/CashDepositModal';
import { HirePurchaseModalProps } from '../HirePurchaseModal/HirePurchaseModal';
import { OutstandingFinanceModalProps } from '../OutstandingFinanceModal/OutstandingFinanceModal';
import { TotalDepositModalProps } from '../TotalDepositModal/TotalDepositModal';
import { TradeInValueModalProps } from '../TradeInValueModal/TradeInValueModal';

export const DynamicHirePurchaseModal = dynamic<HirePurchaseModalProps>(
  async () =>
    (await import('../HirePurchaseModal/HirePurchaseModal')).HirePurchaseModal,
  { ssr: false },
);

export const DynamicCashDepositModal = dynamic<CashDepositModalProps>(
  async () =>
    (await import('../CashDepositModal/CashDepositModal')).CashDepositModal,
  { ssr: false },
);

export const DynamicTradeInValueModal = dynamic<TradeInValueModalProps>(
  async () =>
    (await import('../TradeInValueModal/TradeInValueModal')).TradeInValueModal,
  { ssr: false },
);

export const DynamicOutstandingFinanceModal =
  dynamic<OutstandingFinanceModalProps>(
    async () =>
      (await import('../OutstandingFinanceModal/OutstandingFinanceModal'))
        .OutstandingFinanceModal,
    { ssr: false },
  );

export const DynamicTotalDepositModal = dynamic<TotalDepositModalProps>(
  async () =>
    (await import('../TotalDepositModal/TotalDepositModal')).TotalDepositModal,
  { ssr: false },
);

export const formatCurrencyDecimal = (value: number) =>
  new Intl.NumberFormat('en', {
    style: 'currency',
    currency: CURRENCIES.EUR,
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  }).format(value);

export const formatCurrencyInteger = (value: number) =>
  new Intl.NumberFormat('en-IE', {
    style: 'currency',
    currency: CURRENCIES.EUR,
    maximumFractionDigits: 0,
    minimumFractionDigits: 0,
  }).format(value);

export const formatPercent = (value: number) => `${value}%`;
